// @flow
import type {
  SendAnalytics,
  Initialize,
} from '../../core/ga';

export const sendAnalytics = (
  analyticsQueue: Array<Function>,
): SendAnalytics => (
  args: Object,
) => {
  analyticsQueue.push(function(ga) {
    ga('dst.send', args);
  });
};

export const initialize = (
  analyticsQueue: Array<Function>,
): Initialize => (
  brandId,
  trackerId,
) => {
  analyticsQueue.push(function(ga) {
    ga('create', trackerId, 'auto', 'dst');
    ga('dst.set', 'dimension2', brandId);
    ga('dst.send', 'pageview', {
      // userId: payload.shopperId,
    });
  });
};
